module.exports = __webpack_public_path__ + "img/code_bg.20e6a163.png";